module.exports = __webpack_public_path__ + "static/media/icon-truck-delivery-requested.39876e36.png";